import logger from "./logger"
import { appStartTime } from "../App"
import { Dimensions, METRIC_NAMESPACE, MetricNames, Units } from "./loggerConstants"
import { getBrowser, getDevice } from "./loggerUtils"

function generateEMFHeader(dimensions, metrics) {
    var aws = {
              "Timestamp": Date.now(),
              "CloudWatchMetrics": [
                {
                  "Namespace": METRIC_NAMESPACE,
                  "Dimensions": dimensions,
                  "Metrics": metrics
                }
              ]
            }
    return aws
}

export function logPageView(page) {
    var dimensions = [[Dimensions.Page]]
    var metrics = [
        {
          "Name": MetricNames.PageViews,
          "Unit": Units.Count
        }
    ]
    
    var logContext = {
        "emfLog": {
            "_aws": generateEMFHeader(dimensions, metrics),
            [Dimensions.Page]: page,
            [MetricNames.PageViews]: 1
        }
    }
    logger.info(page + " Page View EMF", logContext)
}

export function logPageLoadTime(page) {
    var dimensions = [[Dimensions.Page]]
    var metrics = [
        {
            "Name": MetricNames.PageLoadtime,
            "Unit": Units.Milliseconds
        }
    ]
    
    var logContext = {
        "emfLog": {
            "_aws": generateEMFHeader(dimensions, metrics),
            [Dimensions.Page]: page,
            [MetricNames.PageLoadtime]: Date.now() - appStartTime
        }
    }
    logger.info(page + " Page Loaded EMF", logContext)
}

export function logUserBrowserAndDevice(userAgent) {
    let device = getDevice(userAgent)
    let browser = getBrowser(userAgent)

    var dimensions = [[Dimensions.Browser], [Dimensions.Device]]
    var metrics = [
        {
            "Name": MetricNames.Count,
            "Unit": Units.Count
        },
        {
            "Name": MetricNames.PageLoadtime,
            "Unit": Units.Milliseconds
        }
    ]

    var logContext = {
        "emfLog": {
            "_aws": generateEMFHeader(dimensions, metrics),
            [Dimensions.Device]: device,
            [Dimensions.Browser]: browser,
            [MetricNames.Count]: 1,
            [MetricNames.PageLoadtime]: Date.now() - appStartTime
        }
    }
    logger.info("Device and Browser EMF", logContext)   
}

export function logErrorMessage(error) {
    var dimensions = [[Dimensions.JSErrors]]
    var metrics = [
        {
          "Name": MetricNames.Count,
          "Unit": Units.Count
        }
      ]

    var logContext = {
        "emfLog": {
            "_aws": generateEMFHeader(dimensions, metrics),
            [Dimensions.JSErrors]: error.message,
            [MetricNames.Count]: 1
        }
    }
    logger.info("Error Message EMF", logContext)
}

export function logUserRegion(region) {
    var dimensions = [[Dimensions.Region]]
    var metrics = [
        {
            "Name": MetricNames.Count,
            "Unit": Units.Count
        }
    ]

    var logContext = {
        "emfLog": {
            "_aws": generateEMFHeader(dimensions, metrics),
            [Dimensions.Region]: region,
            [MetricNames.Count]: 1
        }
    }
    logger.info("User Region EMF", logContext)
}

export function logUserLanguage(language) {
    var dimensions = [[Dimensions.Language]]
    var metrics = [
        {
            "Name": MetricNames.Count,
            "Unit": Units.Count
        }
    ]

    var logContext = {
        "emfLog": {
            "_aws": generateEMFHeader(dimensions, metrics),
            [Dimensions.Language]: language,
            [MetricNames.Count]: 1
        }
    }
    logger.info("User Language EMF", logContext)
}

export function logAwardSummaryDownload(download_type) {
    var dimensions = [[Dimensions.AwardSummaryDownloadType]]
    var metrics = [
        {
            "Name": MetricNames.Count,
            "Unit": Units.Count
        }
    ]

    var logContext = {
        "emfLog": {
            "_aws": generateEMFHeader(dimensions, metrics),
            [Dimensions.AwardSummaryDownloadType]: download_type,
            [MetricNames.Count]: 1
        }
    }
    logger.info("Award Summary Download (" + download_type + ") EMF", logContext)
}
